import * as React from "react";
import styled from "styled-components";
import { ReactComponent as DownloadSvg } from "../../../../assets/downloadIcon.svg";
import { IconButton, Tooltip } from "@material-ui/core";
import DurationIcon from '../../../../assets/durationIcon.svg';
import SlateIcon from '../../../../assets/slateIcon.svg';
import { DownloadType } from "./types";
import { useClipsStore } from "../../../../store/clips";

interface AdMetricsProps {
  duration: number;
  slate: number | undefined;
  onDownload: (type: DownloadType) => void; 
}

export const AdMetrics: React.FC<AdMetricsProps> = ({
  duration,
  slate,
  onDownload,
}) => {
  return (
    <MetricsContainer>
      <MetricItem>
        <MetricIcon
          loading="lazy"
          src={DurationIcon}
          alt="Duration icon"
        />
        <MetricLabel>Duração</MetricLabel>
        <MetricValue>{isNaN(duration) ? 0 : duration}s</MetricValue>
      </MetricItem>
      <MetricItem>
        <MetricIcon
          loading="lazy"
          src={SlateIcon}
          alt="Slate icon"
        />
        <MetricLabel>{slate ? "" : "Sem"} Slate</MetricLabel>
        {slate ? <MetricValue>{slate}s</MetricValue> : <></>}

      </MetricItem>

      <MetricItem>
        <Tooltip title="Download bloco" arrow>
          <DownloadBtn size="small" onClick={() => onDownload('block')}>
            <DownloadSvg width={24} height={24} />
          </DownloadBtn>
        </Tooltip>
      </MetricItem>
    </MetricsContainer>
  );
};

const MetricsContainer = styled.div`
  border-radius: 0 0 3px 3px;
  background-color: rgba(177, 216, 255, 1);
  display: flex;
  flex: 1;
  justify-content: space-between;
  color: #505050;
  fill: #505050;
  white-space: nowrap;
  flex-wrap: wrap;
  padding: 10px;
  font-weight: 500;
  font-size: 16px;
  font-family: "Roboto", "Montserrat";
  margin-bottom: 10px;
  height: 50px;
  @media (max-width: 991px) {
    white-space: initial;
    padding: 0 20px;
  }
`;

const MetricItem = styled.div`
  display: flex;
  gap: 6px;
  @media (max-width: 991px) {
    white-space: initial;
  }
  height: 24px;
  margin-left: 2px;
`;

const MetricIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 20px;
  align-self: center;
`;

const MetricLabel = styled.div`
  margin: auto 0;
`;

const MetricValue = styled.div`
  z-index: 10;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 1.7;
  padding: 0 11px;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

export const DownloadBtn = styled(IconButton)`
  && {
    position: relative;
    top: 2px;
    right: 2px;
    padding: 4px;
    color: #fff;
  }
`;
